export default "__VITE_ASSET__JImhuOPx__"